export default __webpack_public_path__ + "static/media/friendly-skull-collection.fb8e7b4e.png";